import { Navigate, useLocation } from 'react-router-dom';
import { getAuth } from '../lib/auth.js';

export default function ProtectedRoute({ children }) {
  const auth = getAuth();
  const location = useLocation();

  if (!auth) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return children;
}
